export default __webpack_public_path__ + "static/media/home-hotel-banner.2002c213.jpg";